// extracted by mini-css-extract-plugin
var _1 = "background__kEJKO";
var _2 = "crossButtonWrapper__vwUza";
var _3 = "mobileFullSize__ucWbk";
var _4 = "modal__OqoNr";
var _5 = "title__pJ6R5";
export { _1 as "background", _2 as "crossButtonWrapper", _3 as "mobileFullSize", _4 as "modal", _5 as "title" }
export default { "background": _1, "crossButtonWrapper": _2, "mobileFullSize": _3, "modal": _4, "title": _5 }
